import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

export const LabelLinkWrapperExt = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  ${props => props.color && css`
    color: ${props.color};
  `}
   ${props => props.forcePointer && css`
    pointer-events: auto;
  `}
`;

export const LabelLinkWrapperInt = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  ${props => props.color && css`
     color: ${props.color};
  `}
`;



// WEBPACK FOOTER //
// ./src/components/shared/LabelLink/styles.js